import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useScore } from '../../context/ScoreContext';

const LogicPuzzle = ({ isDarkMode }) => {
  const { updateScore, getScore } = useScore();
  const [bestScore, setBestScore] = useState(getScore('logic'));

  const puzzles = [
    // მარტივი
    {
      question: 'რომელი რიცხვია შემდეგი: 2, 6, 12, 20, 30, ?',
      options: ['40', '42', '44', '50'],
      correct: 1,
      difficulty: 'easy'
    },
    {
      question: 'წრეში 5 ვაშლია. 2 აიღე. რამდენი ვაშლი გაქვს?',
      options: ['1', '2', '3', '5'],
      correct: 1,
      difficulty: 'easy'
    },
    {
      question: 'რას იწონის 1 კგ ბამბა vs 1 კგ რკინა?',
      options: ['ბამბა', 'რკინა', 'იგივე', 'არცერთი'],
      correct: 2,
      difficulty: 'easy'
    },
    {
      question: '2 + 2 * 2 = ?',
      options: ['8', '6', '4', '2'],
      correct: 1,
      difficulty: 'easy'
    },
    // საშუალო
    {
      question: 'თუ 5 კატა 5 თაგვს 5 წუთში იჭერს, 100 კატა 100 თაგვს რამდენ წუთში იჭერს?',
      options: ['5', '10', '100', '20'],
      correct: 0,
      difficulty: 'medium'
    },
    {
      question: 'რა არის ყველაზე დიდი რიცხვი, რომელიც შეიძლება ჩაიწეროს 3 ციფრით?',
      options: ['999', '9^9^9', '999^9', '9^99'],
      correct: 1,
      difficulty: 'medium'
    },
    {
      question: 'თუ 3 კაცი 3 საათში 3 ოთახს აშენებს, 6 კაცი 6 საათში რამდენ ოთახს ააშენებს?',
      options: ['6', '9', '12', '18'],
      correct: 2,
      difficulty: 'medium'
    },
    {
      question: 'რა არის √(144) + 5^2?',
      options: ['37', '29', '41', '25'],
      correct: 0,
      difficulty: 'medium'
    },
    // რთული
    {
      question: '1, 1, 2, 3, 5, 8, 13, ? - რა არის შემდეგი რიცხვი?',
      options: ['21', '20', '18', '22'],
      correct: 0,
      difficulty: 'hard'
    },
    {
      question: 'თუ A=1, B=2, ... Z=26, მაშინ "MATH" ჯამი არის?',
      options: ['42', '52', '55', '60'],
      correct: 0,
      difficulty: 'hard'
    },
    {
      question: 'რა არის 7-ის ფაქტორიალი (7!)?',
      options: ['5040', '720', '40320', '840'],
      correct: 0,
      difficulty: 'hard'
    },
    {
      question: 'თუ 2^10 = 1024, მაშინ 2^12 = ?',
      options: ['2048', '4096', '8192', '1024'],
      correct: 1,
      difficulty: 'hard'
    },
    // ძალიან რთული
    {
      question: 'რა არის პი (π) -ს პირველი 5 ციფრი ათწილადის შემდეგ?',
      options: ['14159', '15926', '14159', '26535'],
      correct: 0,
      difficulty: 'expert'
    },
    {
      question: 'განტოლება x^2 - 5x + 6 = 0 -ს ფესვებია?',
      options: ['2,3', '1,6', '3,4', '2,4'],
      correct: 0,
      difficulty: 'expert'
    },
    {
      question: 'რა არის e (ეილერის რიცხვი) მიახლოებით?',
      options: ['2.718', '3.141', '1.618', '2.302'],
      correct: 0,
      difficulty: 'expert'
    }
  ];

  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [selected, setSelected] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [shuffledPuzzles, setShuffledPuzzles] = useState(() => {
    const shuffled = [...puzzles];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  });

  const getDifficultyEmoji = (diff) => {
    switch(diff) {
      case 'easy': return '🟢';
      case 'medium': return '🟡';
      case 'hard': return '🟠';
      case 'expert': return '🔴';
      default: return '';
    }
  };

  const getDifficultyText = (diff) => {
    switch(diff) {
      case 'easy': return 'მარტივი';
      case 'medium': return 'საშუალო';
      case 'hard': return 'რთული';
      case 'expert': return 'ექსპერტი';
      default: return '';
    }
  };

  const handleAnswer = (index) => {
    if (answered) return;
    setSelected(index);
    setAnswered(true);
    
    // ახლა ვითვლით სწორ პასუხს
    const isCorrect = index === shuffledPuzzles[current].correct;
    const newScore = isCorrect ? score + 1 : score;
    setScore(newScore);

    setTimeout(() => {
      if (current < shuffledPuzzles.length - 1) {
        setCurrent(current + 1);
        setSelected(null);
        setAnswered(false);
      } else {
        // თამაშის ბოლოს ვინახავთ ქულას
        updateScore('logic', newScore);
        setBestScore(getScore('logic'));
        setShowResult(true);
      }
    }, 1500);
  };

  const restart = () => {
    const shuffled = [...puzzles];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    setShuffledPuzzles(shuffled);
    setCurrent(0);
    setScore(0);
    setShowResult(false);
    setSelected(null);
    setAnswered(false);
    // განახლება საუკეთესო ქულის
    setBestScore(getScore('logic'));
  };

  const pageStyle = {
    minHeight: '100vh',
    backgroundColor: isDarkMode ? '#0a0a1a' : '#f5f5f5',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const containerStyle = {
    maxWidth: '650px',
    width: '100%',
    background: isDarkMode ? '#1a1a2e' : '#fff',
    padding: '30px',
    borderRadius: '15px',
    boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.1)'
  };

  const progressStyle = {
    width: '100%',
    height: '6px',
    background: isDarkMode ? '#333' : '#e0e0e0',
    borderRadius: '3px',
    margin: '15px 0',
    overflow: 'hidden'
  };

  const progressBarStyle = {
    height: '100%',
    background: 'linear-gradient(90deg, #667eea, #764ba2)',
    width: `${((current + 1) / shuffledPuzzles.length) * 100}%`,
    transition: 'width 0.5s ease'
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <Link to="/games" style={{
          display: 'inline-block',
          padding: '8px 20px',
          marginBottom: '20px',
          background: isDarkMode ? '#333' : '#e0e0e0',
          color: isDarkMode ? '#fff' : '#000',
          textDecoration: 'none',
          borderRadius: '8px',
          transition: 'all 0.3s'
        }}>
          ← უკან
        </Link>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <h2 style={{ color: isDarkMode ? '#fff' : '#000', margin: 0 }}>🧠 Logic Puzzle</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: '#4ade80', fontWeight: 'bold' }}>
              🏆 {bestScore}
            </span>
            <span style={{ color: isDarkMode ? '#aaa' : '#666' }}>
              📊 {score}
            </span>
          </div>
        </div>

        <div style={progressStyle}>
          <div style={progressBarStyle}></div>
        </div>

        {!showResult ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <p style={{ color: isDarkMode ? '#aaa' : '#666', margin: 0 }}>
                კითხვა {current + 1}/{shuffledPuzzles.length}
              </p>
              <p style={{ 
                color: isDarkMode ? '#aaa' : '#666', 
                margin: 0,
                padding: '4px 12px',
                borderRadius: '12px',
                background: isDarkMode ? '#333' : '#f0f0f0',
                fontSize: '14px'
              }}>
                {getDifficultyEmoji(shuffledPuzzles[current].difficulty)} {getDifficultyText(shuffledPuzzles[current].difficulty)}
              </p>
            </div>
            
            <h3 style={{ 
              color: isDarkMode ? '#fff' : '#000', 
              margin: '20px 0',
              fontSize: '20px',
              lineHeight: '1.6'
            }}>
              {shuffledPuzzles[current].question}
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {shuffledPuzzles[current].options.map((opt, idx) => {
                const isCorrect = idx === shuffledPuzzles[current].correct;
                const isSelected = selected === idx;
                let buttonStyle = {
                  padding: '14px 20px',
                  borderRadius: '10px',
                  border: '2px solid',
                  background: isDarkMode ? '#1a1a2e' : '#fff',
                  color: isDarkMode ? '#fff' : '#000',
                  cursor: answered ? 'default' : 'pointer',
                  fontSize: '16px',
                  transition: 'all 0.3s',
                  fontWeight: isSelected ? 'bold' : 'normal'
                };

                if (isSelected) {
                  if (isCorrect) {
                    buttonStyle.borderColor = '#4ade80';
                    buttonStyle.background = '#4ade80';
                    buttonStyle.color = '#fff';
                  } else {
                    buttonStyle.borderColor = '#f87171';
                    buttonStyle.background = '#f87171';
                    buttonStyle.color = '#fff';
                  }
                } else if (answered && isCorrect) {
                  buttonStyle.borderColor = '#4ade80';
                  buttonStyle.background = 'rgba(74, 222, 128, 0.2)';
                } else {
                  buttonStyle.borderColor = isDarkMode ? '#333' : '#ddd';
                }

                return (
                  <button
                    key={idx}
                    onClick={() => handleAnswer(idx)}
                    style={buttonStyle}
                    disabled={answered}
                    onMouseEnter={(e) => {
                      if (!answered && !isSelected) {
                        e.target.style.borderColor = '#667eea';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!answered && !isSelected) {
                        e.target.style.borderColor = isDarkMode ? '#333' : '#ddd';
                      }
                    }}
                  >
                    {opt}
                    {isSelected && (
                      <span style={{ marginLeft: '10px' }}>
                        {isCorrect ? ' ✅' : ' ❌'}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            <div style={{ 
              marginTop: '20px', 
              display: 'flex', 
              justifyContent: 'space-between',
              color: isDarkMode ? '#aaa' : '#666'
            }}>
              <span>✅ სწორი: {score}</span>
              <span>❌ არასწორი: {current + 1 - score}</span>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ color: isDarkMode ? '#fff' : '#000' }}>🏁 დასრულდა!</h2>
            <div style={{ fontSize: '64px', margin: '20px 0' }}>
              {score >= shuffledPuzzles.length * 0.8 ? '🎉' : 
               score >= shuffledPuzzles.length * 0.5 ? '😊' : '😅'}
            </div>
            <p style={{ fontSize: '32px', color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }}>
              {score}/{shuffledPuzzles.length}
            </p>
            <p style={{ fontSize: '18px', color: isDarkMode ? '#aaa' : '#666' }}>
              სიზუსტე: {Math.round((score / shuffledPuzzles.length) * 100)}%
            </p>
            <div style={{ 
              margin: '20px 0', 
              padding: '15px',
              background: isDarkMode ? '#2a2a4a' : '#f0f0f0',
              borderRadius: '10px'
            }}>
              <p style={{ color: '#4ade80', fontWeight: 'bold', margin: 0 }}>
                🏆 საუკეთესო შედეგი: {bestScore}
              </p>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button onClick={restart} style={{
                padding: '12px 30px',
                background: '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#764ba2'}
              onMouseLeave={(e) => e.target.style.background = '#667eea'}>
                🔄 თავიდან
              </button>
              <Link to="/games" style={{
                padding: '12px 30px',
                background: isDarkMode ? '#333' : '#e0e0e0',
                color: isDarkMode ? '#fff' : '#000',
                textDecoration: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                transition: 'all 0.3s'
              }}>
                📋 თამაშები
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogicPuzzle;